import React from 'react';
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Avatar, Badge, Collapse, IconButton, Table, TableBody, TableCell, TableHead, TableRow, TableFooter, Tooltip, withStyles } from '@material-ui/core';
import _ from 'lodash';
import EnhancedTableHead from '../../enhencedTableHead/EnhancedTableHead';
import { ColumnModel } from '../../../models/ColumnModel';
import routePaths from '../../../routePaths'
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import AlarmIcon from "@material-ui/icons/NotificationsActive";
import NotUprightIcon from "@material-ui/icons/Redo";
import PauseIcon from "@material-ui/icons/Pause";
import ReservationIcon from "@material-ui/icons/Timelapse";
import RideIcon from "@material-ui/icons/DirectionsBike";
import ServiceIcon from "@material-ui/icons/Build";
import StarIcon from "@material-ui/icons/Star";
import moment from "moment";
import { BikeModel, BikeTechnicalStatus } from "../../../models/BikeModel";

const styles = theme => ({
  rowWithError: {
    backgroundColor: theme.palette.error.light,
  },
  normalRow: {
    backgroundColor: 'white',
  }
});

const columns = [
  new ColumnModel("name", false, false, "Strefa"),
  new ColumnModel("enabledElectricBikesCount", true, false, "Liczba włączonych rowerów elektrycznych"),
  new ColumnModel("enabledStandardBikesCount", true, false, "Liczba włączonych rowerów standardowych"),
  new ColumnModel("disabledBikesCount", true, false, "Liczba wyłączonych rowerów"),
  new ColumnModel("minimum", true, false, "Minimum"),
  new ColumnModel("bikesCount", true, false, "Razem"),
  new ColumnModel("maksimum", true, false, "Maksimum"),
];

class RelocationReportTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      order: "asc",
      orderBy: "name",
      filteredZones: props.relocationData.zones,
      expandedRows: {},
    };

    this.handleRequestSort = this.handleRequestSort.bind(this);
    this.handleToggleRow = this.handleToggleRow.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ filteredZones: nextProps.relocationData.zones });
  }

  handleRequestSort(event, property) {
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }

    const data = _.orderBy(this.state.filteredZones, [orderBy], [order]);

    this.setState({ order, orderBy, filteredZones: data });
  }

  handleToggleRow(itemId) {
    this.setState(prevState => ({
      expandedRows: {
        ...prevState.expandedRows,
        [itemId]: !prevState.expandedRows[itemId],
      },
    }));
  }

  renderTechnicalStatus(bike) {
    const technicalStatus = BikeTechnicalStatus[bike.technicalStatus] ||
      BikeTechnicalStatus.functional;

    return (
      <span style={{ color: technicalStatus.color, fontSize: 12, fontWeight: 500 }}>
        {technicalStatus.name}
      </span>
    );
  }

  renderIconDecoration(bike, iconElement) {
    const color = bike.hasAlarmEnabled ? "error" : "default";
    const badgeBaseIconStyle = { width: 12, height: 12 };

    if (bike.ongoingPause)
      return (
        <Badge color={color} badgeContent={<PauseIcon style={badgeBaseIconStyle} />}>
          {iconElement}
        </Badge>
      );
    if (bike.isRentalRestricted)
      return (
        <Badge color={color} badgeContent={<ServiceIcon style={badgeBaseIconStyle} />}>
          {iconElement}
        </Badge>
      );
    if (bike.isRented)
      return (
        <Badge color={color} badgeContent={<RideIcon style={badgeBaseIconStyle} />}>
          {iconElement}
        </Badge>
      );
    if (bike.isReserved)
      return (
        <Badge color={color} badgeContent={<ReservationIcon style={badgeBaseIconStyle} />}>
          {iconElement}
        </Badge>
      );
    if (bike.hasAlarmEnabled)
      return (
        <Badge color={color} badgeContent={<AlarmIcon style={badgeBaseIconStyle} />}>
          {iconElement}
        </Badge>
      );
    if (bike.isOrientedUpright === false)
      return (
        <Badge color={color} badgeContent={<NotUprightIcon style={badgeBaseIconStyle} />}>
          {iconElement}
        </Badge>
      );

    return iconElement;
  }

  renderStatusIcon(bike) {
    return (
      <div style={{ display: "inline-flex", alignItems: "center", gap: 3 }}>
        <Tooltip title={BikeModel.getBikeStatusDescription(bike)} placement="right">
          {this.renderIconDecoration(
            bike,
            <Avatar src={bike.bikeIcon} style={{ width: 24, height: 24 }} />
          )}
        </Tooltip>
        {bike.isSponsored ? (
          <Tooltip title="Rower sponsorski">
            <StarIcon color="primary" style={{ width: 16, height: 16 }} />
          </Tooltip>
        ) : null}
      </div>
    );
  }

  render() {
    const { relocationData, classes } = this.props;
    const { filteredZones, expandedRows } = this.state;

    return (
      <Table>
        <EnhancedTableHead
          order={this.state.order}
          orderBy={this.state.orderBy}
          onRequestSort={this.handleRequestSort}
          headCells={columns}
        />
        <TableBody>
          {filteredZones && filteredZones.map(item => {
            const hasBikes = Array.isArray(item.bikes) && item.bikes.length > 0;
            const isExpanded = Boolean(expandedRows[item.id]);

            return (
              <React.Fragment key={item.id}>
                <TableRow
                  className={classNames(
                    item.minimum != null &&
                    item.maximum != null &&
                    (item.bikesCount < item.minimum || item.bikesCount > item.maximum)
                      ? classes.rowWithError
                      : classes.normalRow
                  )}
                >
                  <TableCell>
                    {hasBikes && (
                      <IconButton
                        size="small"
                        style={{
                          padding: 0,
                          marginRight: 4,
                          verticalAlign: "middle",
                        }}
                        onClick={() => this.handleToggleRow(item.id)}
                        aria-label={isExpanded ? "Zwiń listę rowerów" : "Rozwiń listę rowerów"}
                      >
                      {isExpanded ? (
                        <KeyboardArrowUpIcon style={{ fontSize: 16 }} />
                      ) : (
                        <KeyboardArrowDownIcon style={{ fontSize: 16 }} />
                      )}
                      </IconButton>
                    )}

                    {item.name}
                  </TableCell>

                  <TableCell align="right">{item.enabledElectricBikesCount}</TableCell>
                  <TableCell align="right">{item.enabledStandardBikesCount}</TableCell>
                  <TableCell align="right">{item.disabledBikesCount}</TableCell>
                  <TableCell align="right">{item.minimum}</TableCell>
                  <TableCell align="right">{item.bikesCount}</TableCell>
                  <TableCell align="right">{item.maximum}</TableCell>
                </TableRow>

                {hasBikes && (
                  <TableRow>
                    <TableCell colSpan={7} style={{ paddingTop: 0, paddingBottom: 0, borderBottom: "none" }}>
                      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell width={60}>Lp.</TableCell>
                              <TableCell>Status</TableCell>
                              <TableCell>Status techniczny</TableCell>
                              <TableCell>Numer roweru</TableCell>
                              <TableCell>Bateria blokady</TableCell>
                              <TableCell>Bateria roweru</TableCell>
                              <TableCell>Aktualizacja</TableCell>
                              <TableCell>Czas GPS</TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {item.bikes.map((bike, index) => (
                              <TableRow key={bike.id}>
                                <TableCell>{index + 1}.</TableCell>
                                <TableCell>{this.renderStatusIcon(bike)}</TableCell>
                                <TableCell>{this.renderTechnicalStatus(bike)}</TableCell>
                                <TableCell>
                                  <Link to={`${routePaths.bikes}/${bike.id}`}>
                                    {bike.bikeNumber}
                                  </Link>
                                </TableCell>
                                <TableCell>{bike.lockBatteryLevel ? `${bike.lockBatteryLevel}%` : "-"}</TableCell>
                                <TableCell>{bike.bikeBatteryLevel != null ? `${bike.bikeBatteryLevel}%` : "-"}</TableCell>
                                <TableCell>{bike.lockTimestamp ? moment(bike.lockTimestamp).format("DD.MM.YYYY HH:mm") : "-"}</TableCell>
                                <TableCell>{bike.gpsTimestamp ? moment(bike.gpsTimestamp).format("DD.MM.YYYY HH:mm") : "-"}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                )}
              </React.Fragment>
            );
          })}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TableCell><strong>Poza strefą</strong></TableCell>
            <TableCell align="right">{relocationData.enabledElectricBikesOutsideZonesCount}</TableCell>
            <TableCell align="right">{relocationData.enabledStandardBikesOutsideZonesCount}</TableCell>
            <TableCell align="right">{relocationData.disabledBikesOutsideZonesCount}</TableCell>
            <TableCell align="right">{null}</TableCell>
            <TableCell align="right">{relocationData.bikesOutsideZonesCount}</TableCell>
            <TableCell align="right">{null}</TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    );
  }
}

RelocationReportTable.propTypes = {
  classes: PropTypes.object.isRequired,
  relocationData: PropTypes.object.isRequired,
};

export default withStyles(styles)(RelocationReportTable);
